<app-mini-loader *ngIf="loading"></app-mini-loader>
<app-colapsable
  *ngIf="datosAsegurado && !loading"
  title="DATOS DEL CONTRATANTE"
  ($expandedChange)="expandChange()"
>
  <div body>
    <div class="container-asegurado">
      <div class="rseparator margin-line"></div>
      <div class="data-pair num-poliza margin-grid margin-line">
        <span class="label">Número de póliza</span>
        <span class="uppercase value">{{ datosAsegurado?.Numero }}</span>
      </div>

      <div class="data-pair nom-asegurado margin-grid margin-line">
        <span class="label">Nombre Asegurado</span>
        <span class="uppercase value">{{
          datoContratante?.Nombre ||
            ' ' ||
            datoContratante?.ApellidoPaterno ||
            ' ' ||
            datoContratante?.ApellidoMaterno
        }}</span>
      </div>
      <div class="rseparator2 margin-line"></div>

      <div class="data-pair tipo-pension margin-grid">
        <span class="label">Tipo Pensión</span>
        <span class="uppercase value">{{ datosAsegurado?.TipoPension }}</span>
      </div>
    </div>
    <!--button
      class="btn_liquidacion"
      (click)="solicitarCertificado()"
      [disabled]="is_SolicitudCert === true"
    >
      Solicitud de Certificado de Liquidación
    </button>-->
    <div class="container-alert" *ngIf="is_SolicitudCert && thiscasebyid">
      Hemos recibido correctamente su solicitud de portabilidad. El número es:
      <p>{{ thiscasebyid }}</p>
      <br />
      En un plazo de 3 días hábiles, le enviaremos los documentos a su email. En
      caso de alguna inquietud, puede consultar a través de
      contactovida@security.cl informando su número de solicitud.
    </div>
    <div class="container-try-alert" *ngIf="is_SolicitudCert && !thiscasebyid">
      Usted ya ha realizado su solicitud de certificado de liquidación para
      iniciar el proceso de portabilidad financiera. En caso de alguna
      inquietud, puede consultar a través de contactovida@security.cl.
    </div>
    <div class="container-error-alert" *ngIf="errorSC">
      En caso de algún problema, puede consultar a través de
      contactovida@security.cl informando su solicitud.
    </div>
  </div>
</app-colapsable>
